<template>
  <div class="data-container">
    <div v-for="dt,key in showData" :class="'tables '+ key" v-if="dt.length > 0">
      <div class="table-title">
        <span v-text="(legenda[key]||key)"></span>
        <span v-if="dt[0].VIGENCIA" v-text="$t('validity_header_otm')+dt[0].VIGENCIA+')'"></span>

        <div class="checkbox-container" v-if="!dt.shouldNotToggle">
          <input type="checkbox" v-model="dt.Ativo" v-on:change="changeValueFomAtivo(dt)" />
        </div>
      </div>

      <div class="collums tit-col" v-bind:style="calcGrid(dt[0], dt.shouldNotToggle)">
        <div
          class="tit-tab"
          v-for="dtitemLabel,key in dt[0]"
          v-if="!restriction.includes(key) && (!dt.shouldNotToggle && key == 'Ativo' || key != 'Ativo') "
        >
          <span v-text="legenda[key]||key"></span>
        </div>
      </div>

      <div
        class="lines"
        v-for="dtitem in dt"
        v-bind:class="{desactivated: dtitem.Ativo == false, someError: hasError(dtitem)}"
      >
        <div class="collums" v-bind:style="calcGrid(dt[0], dt.shouldNotToggle)">
          <div v-for="dtprop,key in dtitem" v-if="!restriction.includes(key)">
            <span
              v-if="key!='Ativo'"
              v-bind:title="brokenDataWarning(dtitem) || legendaDado[dtprop] || dtprop"
              v-text="legendaDado[dtprop] || dtprop"
            ></span>

            <div
              class="checkbox-container"
              v-if="key =='Ativo' && !dt.shouldNotToggle"
              :title="brokenDataWarning(dtitem)"
            >
              <input
                :style="blockBrokenData(dtitem)"
                type="checkbox"
                v-model="dtitem.Ativo"
                v-on:change="changeValueFomAtivo(dt, dtitem)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { t } from 'i18next';

export default {
  name: "OtimizadorData",
  props: ["dataFromOtm"],
  data() {
    return {
      restriction: [
        "CDTIPOPRAT",
        "NRGRUPOPRATOSERV_COMB",
        "CD_GRUPO_DE_PRATO_COMB",
        "CD_GRUPO_DE_PRATO",
        "NRGRUPOPRATOSERV",
        "VLR_CUSTO_PRATO",
        "VLR_CUSTO_PRATO_4",
        "NOME_GRUPO_COMB",
        "NOME_GRUPO_PRATO_COMB",
        "NOME_GRUPO",
        "POSSUI_GRUPO",
        "VIGENCIA",
        "COD_GRP_TIP_PRATO_COMB",
        "COD_GRP_TIP_PRATO",
        "COD_PRATO_COMB",
        "NRGRUPOPRATOSERV",
        "NUM_GRP_PRATO",
        "COD_FILIAL",
        "COD_SERVICO",
        "COD_PRATO",
        "COD_PRODUTO",
        "SEQ"
      ],
      legendaDado: {
        R: t('restr'),
        P: t('pref'),
        O: t('obrg')
      },
      legenda: {
        NRINGREDIENTEPRINC: t('code_from_ingr'),
        NMINGREDIENTEPRINC: t('name_from_ingr'),
        NRFORMAPREPARO: t('code_of_the_mode'),
        NMFORMAPREPARO: t('name_of_the_mode'),
        CDAPRERECE: t('code_of_the_cut'),
        NMAPRERECE: t('name_of_the_cut'),
        tp_corte: t('type_of_cut'),
        md_preparo: t('method_of_preparation'),
        ing_princ: t('main_ingredients'),
        grupo_prato: t('dishes_per_group'),
        CDAGRUPGRPRAT: t('code_grouping'),
        NMAGRUPGRPRAT: t('name_grouping'),
        CDGRUPOPRATO: t('code_plate_group'),
        NOM_GRUPOPRATO: t('name_plate_group'),
        NMPRATO: t('name_plate'),
        res_prato_combinacao: t('restriction_of_combination_of_dishes'),
        NOME_GRUPO_COMB: t('COMB_GROUP_NAME'),
        NOME_PRATO_COMB: t('NAME_DISH_COMB'),
        CODIGO_PRATO_COMB: t('CODE_COMB_PLATE'),
        ARVORE_PRATO: t('TREE_PLATE'),
        ARVORE_PRATO_COMB: t('TREE_PLATE_COMB'),
        ARVORE_PRODUTO: t('PRODUCT_TREE'),
        NOME_PRODUTO: t('PRODUCT_NAME'),
        NOME_AGRUPAMENTO: t('grouping_name'),
        CODIGO_PRATO: t('cod_dish'),
        NOME_PRATO: t('dish_name'),
        NOME_DO_GRUPO: t('DISH_GROUP_NAME'),
        NOME_GRUPO_PRATO: t('DISH_GROUP_NAME'),
        NOME_GRUPO_TIPO_PRATO: t('DISH_TYPE_GROUP_NAME'),
        NOME_GRUPO_TIPO_PRATO_COMB: t('DISH_TYPE_GROUP_NAME_COMB'),
        frq_grupo_prato_mes: t('dish_group_frequency_per_month'),
        COD_FILIAL: t('CODE_BRANCH'),
        COD_SERVICO: t('CODE_SERVICE'),
        NUM_GRP_PRATO: t('DISH_GROUP_NUMBER'),
        MIN_MES_GRP: t('MIN_MES_GRP'),
        MAX_MES_GRP: t('MAX_MES_GRP'),
        MAX_SEM_GRP: t('MAX_SEM_GRP'),
        frq_prato_mes: t('dish_frequency_per_month'),
        COD_PRATO: t('CODE_DISH'),
        MIN_MES_PRATO: t('MIN_MES_PLATE'),
        MAX_MES_PRATO: t('MAX_MES_PLATE'),
        MAX_SEMANA: t('MAX_WEEK'),
        frq_prod_grupo_prato: t('product_frequency_by_dish_group'),
        NRGRUPOPRATOSERV: t('SERVING_DISH_GROUP_NR'),
        COD_PRODUTO: t('CODE_PRODUCT'),
        MIN_MES_PRD: t('MIN_MES_PRD'),
        MAX_MES_PRD: t('MAX_MES_PRD'),
        limite_per_capita: t('per_capita_limit'),
        QTD_MIN_GRAMAGEM: t('QTD_MIN_WEIGHT'),
        QTD_MAX_GRAMAGEM: t('QTD_MAX_WEIGHT'),
        prato_combinacao: t('combination_of_dishes'),
        COD_GRP_TIP_PRATO: t('CODE_GRP_TYPE_OF_DISH'),
        COD_PRATO_COMB: t('CODE_COMB_PLATE'),
        COD_GRP_TIP_PRATO_COMB: t('CODE_GRP_TIP_PLATE_COMB'),
        res_grupo_prato: t('dish_group_product_restriction'),
        utilizacao_prato_semana: t('use_of_dish_group_in_the_week'),
        IND_SEGUNDA: t('MONDAY'),
        IND_TERCA: t('TUESDAY'),
        IND_QUARTA: t('WEDNESDAY'),
        IND_QUINTA: t('THURSDAY'),
        IND_SEXTA: t('FRIDAY'),
        IND_SABADO: t('SATURDAY'),
        IND_DOMINGO: t('SUNDAY'),
        IDPRIMSEM: t('subtitle_first_week'),
        IDSEMANA2: t('subtitle_second_week'),
        IDSEMANA3: t('subtitle_third_week'),
        IDSEMANA4: t('subtitle_fourth_week'),
        IDULTMSEM: t('subtitle_last_week'),
        IDFERIADO: t('subtitle_holiday')
      },
      showData: {
        frq_grupo_prato_mes: [],
        frq_prato_mes: [],
        frq_prod_grupo_prato: [],
        limite_per_capita: [],
        prato_combinacao: [],
        res_prato_combinacao: [],
        res_grupo_prato: [],
        utilizacao_prato_semana: [],
        tp_corte: [],
        md_preparo: [],
        ing_princ: [],
        grupo_prato: []
      }
    };
  },
  methods: {
    hasError(dtitem) {
      return dtitem.VLR_CUSTO_PRATO === null && dtitem.VLR_CUSTO_PRATO_4 === null;
    },
    brokenDataWarning(dtitem) {
      if (dtitem.POSSUI_GRUPO == "N") {
        return t('there_are_dishes_in_this_relation_that_are_not_associated');
      } else if (dtitem.VLR_CUSTO_PRATO === null && dtitem.VLR_CUSTO_PRATO_4 === null) {
        return t('dish_has_product_with_zero_cost_or_outdated_for_more_than_3_months');
      } else if (dtitem.VLR_CUSTO_PRATO === null) {
        return t('dish_has_product_with_outdated_cost');
      }
      return null;
    },
    blockBrokenData(dtitem) {
      return dtitem.POSSUI_GRUPO == "N"
        ? "pointer-events: none"
        : "pointer-events: auto";
    },
    calcGrid(size, shouldNotToggle) {
      if (size) {
        let gtc = "grid-template-columns: ";
        let cols = Object.keys(size).filter(c => !this.restriction.includes(c))
          .length;
        if (shouldNotToggle && shouldNotToggle == true) {
          cols = cols - 1;
        }
        let perc = "";

        for (let i = 0; i < cols; i++) {
          perc = 100 / cols;
          perc = perc + "% ";
          gtc = gtc + perc;
        }
        return gtc;
      }
    },
    changeValueFomAtivo(row, item = null) {
      if (row && !item) {
        row.map(dt => {
          if (dt.POSSUI_GRUPO != "N") {
            dt.Ativo = row.Ativo;
          }
        });
      } else {
        if (row.find(i => i.Ativo == false)) {
          row.Ativo = false;
        } else {
          row.Ativo = true;
        }
      }
      this.$forceUpdate();
    }
  },
  mounted() {
    //console.log(this.showData);
    this.showData.frq_grupo_prato_mes = this.dataFromOtm.frq_grupo_prato_mes.data;
    this.showData.frq_prato_mes = this.dataFromOtm.frq_prato_mes.data;
    this.showData.frq_prod_grupo_prato = this.dataFromOtm.frq_prod_grupo_prato.data;
    this.showData.limite_per_capita = this.dataFromOtm.limite_per_capita.data;
    this.showData.prato_combinacao = this.dataFromOtm.prato_combinacao.data;
    this.showData.res_prato_combinacao = this.dataFromOtm.res_prato_combinacao.data;
    this.showData.res_grupo_prato = this.dataFromOtm.res_grupo_prato.data;
    this.showData.utilizacao_prato_semana = this.dataFromOtm.utilizacao_prato_semana.data;
    this.showData.tp_corte = this.dataFromOtm.tp_corte.data;
    this.showData.md_preparo = this.dataFromOtm.md_preparo.data;
    this.showData.ing_princ = this.dataFromOtm.ing_princ.data;
    this.showData.grupo_prato = this.dataFromOtm.grupo_prato.data;
    this.showData.grupo_prato.shouldNotToggle = true;

    let arr = Object.keys(this.showData);
    for (let i = 0; i < arr.length; i++) {
      const pos = arr[i];
      if (this.showData[pos].length > 0) {
        this.showData[pos].map(dt => {
          if (dt.POSSUI_GRUPO) {
            dt.Ativo = dt.POSSUI_GRUPO == "S";
          } else {
            dt.Ativo = true;
          }
          if (["tp_corte", "md_preparo", "ing_princ"].includes(pos) && (dt.CDAPRERECE === null || dt.NRFORMAPREPARO === null || dt.NRINGREDIENTEPRINC === null)) {
            dt.Ativo = false;
          }
        });
        this.showData[pos].Ativo = true;
      }
    }

    if(this.showData.frq_grupo_prato_mes.length){
      this.showData.frq_grupo_prato_mes.push({'withoutFreq': t('USE_OUT_OF_TERM_GROUPS'), 'Ativo': false})
    }
  },
  updated() {
    this.$emit("editedData", this.showData);
  }
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");

.checkbox-container {
  position: relative;
  height: 100%;
  max-width: 50px;
  margin: auto;
  &:before {
    content: "";
    height: 2px;
    margin: auto;
    position: absolute;
    top: 5px;
    right: 5px;
    left: 5px;
    bottom: 5px;
    z-index: 2;
    background: #000;
  }
  input[type="checkbox"] {
    .clicavel;
    display: block;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    height: 0;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
    }
    &:after {
      content: "";
      z-index: 2;
      top: 5px;
      position: absolute;
      background: rgba(0, 0, 0, 0.9);
      left: 5px;
      height: 60%;
      right: 55%;
      border-radius: 100%;
      .default-animation(0.5s);
    }
    &:checked {
      &:before {
        border-color: @vermelho;
      }
      &:after {
        left: 55%;
        right: 5px;
        background: @vermelho;
        opacity: 1;
      }
    }
  }
}
.data-container {
  .user-not-select;
  margin: 0 15px;
  .tables {
    --otm-radius-card: 8px;
    --otm-radius-modal: 12px;
    --otm-shadow-soft: 0 6px 16px rgba(19, 24, 41, 0.1);
    --otm-shadow-raised: 0 12px 28px rgba(19, 24, 41, 0.12);

    margin: 0 0 30px 0;
    border-radius: var(--otm-radius-modal);
    border: 1px solid rgba(33, 33, 70, 0.14);
    background: linear-gradient(180deg, #fbfcff 0%, #f5f8ff 100%);
    box-shadow: var(--otm-shadow-raised);
    padding: 10px 10px 8px;

    .table-title {
      border-radius: var(--otm-radius-card);
      position: relative;
      display: block;
      background: linear-gradient(160deg, #24244f 0%, #1e2c6c 100%);
      border: 1px solid rgba(255, 255, 255, 0.14);
      color: #fff;
      margin-bottom: 8px;
      text-transform: uppercase;
      padding: 8px 0 8px 12px;
      letter-spacing: 0.02em;

      > span:first-of-type {
        font-size: 0.76rem;
        font-weight: 800;
      }

      > span:last-of-type {
        font-size: 0.71rem;
        color: rgba(255, 255, 255, 0.86);
      }

      .checkbox-container {
        width: 150px;
        position: absolute;
        right: 5px;
        top: 0;
        &:before {
          background: #c4c4c4;
        }
        input[type="checkbox"] {
          &:after {
            background: #c4c4c4;
          }
          &:checked {
            &:after {
              background: @vermelho;
            }
          }
        }
      }
    }
    .collums {
      font-size: 0.8rem;
      display: grid;
      text-align: center;

      &.tit-col {
        border: 1px solid rgba(33, 33, 70, 0.12);
        border-radius: var(--otm-radius-card);
        background: linear-gradient(180deg, rgba(226, 232, 247, 0.9) 0%, rgba(213, 222, 240, 0.9) 100%);
        margin-bottom: 4px;

        div {
          display: table;
          vertical-align: middle;
          margin: auto;
          max-width: 90%;

          span {
            display: table;
            margin: auto;
            text-align: center;
            vertical-align: middle;
            padding: 7px 8px;
            text-transform: uppercase;
            font-weight: 700;
            color: #243261;
            font-size: 0.71rem;
          }
        }
      }
    }

    .lines {
      &.someError {
        color: #c62828;
        border-color: rgba(198, 40, 40, 0.28);
      }

      &.desactivated {
        opacity: 0.6;
        filter: grayscale(0.08);
      }

      border: 1px solid rgba(33, 33, 70, 0.09);
      border-radius: var(--otm-radius-card);
      margin-bottom: 4px;
      background: #ffffff;
      transition: border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;

      &:nth-of-type(2n) {
        background: rgba(236, 241, 252, 0.78);
      }

      &:hover {
        border-color: rgba(30, 44, 108, 0.28);
        box-shadow: var(--otm-shadow-soft);
        transform: translateY(-1px);
      }

      .collums div {
        position: relative;

        > span {
          padding: 7px 8px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: block;
          color: #1f2b56;
          font-size: 0.79rem;
        }
      }
    }

    &.frq_grupo_prato_mes .lines:last-of-type .collums{
      grid-template-columns: 80% 20% !important;
    }
  }
}

@media screen and (max-width: 900px) {
  .data-container {
    .tables {
      padding: 8px 8px 6px;

      .lines .collums div > span {
        font-size: 0.75rem;
      }

      .table-title .checkbox-container {
        width: 120px;
      }
    }
  }
}
</style>
